import api from 'Components/_helpers/api';

export async function loginApi(email, password) {
  return new Promise((resolve, reject) => {
    api.post('/Authentication/Login', {
      email: email,
      password: password
    })
    .then((res) =>{
      resolve(res.data);
    })
    .catch((error) => {
      reject(error)
    });
  })
  
}